import React from 'react';
// import useDarkMode from '../../../hooks/useDarkMode';
import Footer from '../../../layout/Footer/Footer';
import { AteneaWhitebrand } from '../../../assets/AteneaPoweredBy';

const PurdyDefaultFooter = () => {
	// const { darkModeStatus } = useDarkMode();

	return (
		<Footer style={{ background: 'transparent', margin: '1rem 0 0', boxShadow: 'none' }}>
			<div className='container-fluid d-flex align-items-center justify-content-center'>
				<a
					href='https://www.atenea.ai/'
					className='d-flex align-items-center justify-content-center w-50'
					style={{
						textDecoration: 'none',
						color: 'rgb(50,50,50)',
					}}>
					<img
						src={AteneaWhitebrand}
						alt='ateneaLogo'
						style={{
							// filter: "grayscale(1) drop-shadow(0 0 0rem #8a8a8a)",
							height: '20px',
						}}
					/>
				</a>
			</div>
		</Footer>
	);
};

export default PurdyDefaultFooter;
